import { FormEvent, Suspense, useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { registerModal, CloseModal } from '@gluedigital/modal'
import Loading from 'src/components/Loading/Loading'
import { useAssistance, useUser } from 'src/hooks/api'

import './ClientModal.sass'

const ClientModal = () => {
  const [status, setStatus] = useState('')
  const baseUser = useUser('me')
  const [user, setUser] = useState(baseUser)
  const { username, email, phone } = user
  const intl = useIntl()

  const assistance = useAssistance(username, email, phone)

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    setStatus('loading')
    const p = assistance()
    p.then((res) => {
      setStatus('success')
      console.log(res)
    }).catch((e) => {
      setStatus('error')
      console.error(e)
    })
  }
  let content = (
    <div className="content">
      <h1>
        <FormattedMessage id="client-modal.title" />
      </h1>
      <p>
        <FormattedMessage id="client-modal.text" />
      </p>
      <form onSubmit={(e) => handleSubmit(e)}>
        <h2>
          <span className="icon icon-mail" />
          <span>
            <FormattedMessage id="client-modal.form.title" />
          </span>
        </h2>
        <p>
          <FormattedMessage id="client-modal.form.text" />
        </p>
        <label>
          <input
            type="text"
            name="firstName"
            placeholder={intl.formatMessage({ id: 'placeholder.name' })}
            required
            value={username}
            onChange={(e) => setUser({ ...user, username: e.target.value })}
          />
        </label>
        <label>
          <input
            type="email"
            name="email"
            required
            placeholder={intl.formatMessage({ id: 'placeholder.email' })}
            value={email}
            onChange={(e) => setUser({ ...user, email: e.target.value })}
          />
        </label>
        <label>
          <input
            type="text"
            name="phone"
            required
            placeholder={intl.formatMessage({ id: 'placeholder.tel' })}
            value={phone}
            onChange={(e) => setUser({ ...user, phone: e.target.value })}
          />
        </label>
        <button className="filled">
          <FormattedMessage id="accept" />
        </button>
      </form>
    </div>
  )
  if (status === 'success') {
    content = (
      <div className="success-status">
        <div className="illustration" />
        <h2>
          <FormattedMessage id="client-modal.success-status.title" />
        </h2>
        <CloseModal>
          <button className="filled">
            <FormattedMessage id="accept" />
          </button>
        </CloseModal>
      </div>
    )
  } else if (status === 'error') {
    content = (
      <div className="error-status">
        <div className="illustration" />
        <h2>
          <FormattedMessage id="client-modal.error-status.title" />
        </h2>
        <CloseModal>
          <button className="filled">
            <FormattedMessage id="accept" />
          </button>
        </CloseModal>
      </div>
    )
  }

  return (
    <div className="client-modal">
      {status === 'loading' ? <Loading /> : content}
    </div>
  )
}

const ClientModalWrapper = () => (
  <Suspense fallback={<Loading />}>
    <ClientModal />
  </Suspense>
)

registerModal('client-modal', ClientModalWrapper)
